// extracted by mini-css-extract-plugin
module.exports = {"root":"DlpListingsInstabook_root__4ZLIO","subTitle":"DlpListingsInstabook_subTitle___m4PO","icon":"DlpListingsInstabook_icon___fire"};